import React, { useContext, useEffect } from "react";

import { Context, fetchClasses } from "../../../teacherStore";
import SelectClass from "../../../templates/Select/Class";

export default () => {
  const { state, dispatch } = useContext(Context);
  const classes = state.classes;

  useEffect(() => {
    dispatch(fetchClasses());
  }, [dispatch]);

  return <SelectClass classes={classes} forward />;
};
